module.exports = {
    "baseUrl": "https://api-v4.primrose.health",
    "systemName": "System Prod",
    "stripeKey": "pk_live_51Ia02yIg43ZjHHGkZRwf5Ap3qTBlvEKJIe08edJWqyVDlEs30E8wHlnWl8XWqfzlEufmqMwattqTzzojGlDc6Sul00stDc8rJm",
    "companyTitle": "Trillium Check in",
    "metaTitle": "Trillium Check in",
    "metaDescription": "Scheduler for physicians and clinics from Trillium Health",
    "favicon": "%PUBLIC_URL%/favicon.png",
    "companyName": "Trillium Technologies",
    "copyRight": "Primrose Health and Trillium Technologies are trademarks of their respective owners.",
    "companyKey": "trillium",
    "redirectUrl": "https://trillium.health/",
    "cdnUrl": "https://cdn.primrose.health"
}